export default data => {
  const { address, city, state, zipCode } = data || {};
  return `${address || ''}, ${city || ''}, ${state || ''} ${zipCode || ''}`;
};
